module.exports = "app.filter('momentDate', function () {\n  return function (value, format) {\n    return moment(value).format(format);\n  };\n});"